/* eslint-disable import/no-anonymous-default-export */
import request from "../request";

const requestOtp = (email) => request.post("request-otp", { email });

const verifyOtp = (email, code) => request.post("login", { email, code });

const logout = () => request.post("logout");

const getProfile = () => request.get("users/me");

export default {
	requestOtp,
	verifyOtp,
	logout,
	getProfile,
};
